<template>
  <div class='results-base'>
    <header-base />
    <v-container>
      <h1>{{roundName}}</h1>
      <h2>{{(results && results.solverName) || profileID}}'s Results</h2>
      <review-table :solverData='[results]' :scrambles='scrambles' />
    </v-container>
  </div>
</template>

<script>
import utils from '@/modules/utils'
import RoundsService from '@/services/TPC/RoundsService'

import HeaderBase from '@/components/TPC/Header/Base'
import ReviewTable from '@/components/TPC/Shared/ReviewTable'

export default {
  name: 'results-base',
  components: {
    HeaderBase,
    ReviewTable
  },
  data () {
    return {
      results: {},
      scrambles: [],
    }
  },
  methods: {},
  computed: {
    roundID () {
      return this.$route.params.rid
    },
    profileID () {
      return this.$route.params.sid.split('o')[0]
    },
    solverOrder () {
      return this.$route.params.sid.split('o')[1]
    },
    roundName () {
      return this.$store.state.eventName ? `${this.$store.state.eventName} ${utils.roundNameSuffix(this.roundID)}` : 'Round ' + this.roundID
    }
  },
  async created () {
    const {data: resultsData} = await RoundsService.listResults('solver', {
      roundID: this.roundID,
      profileID: this.profileID
    })
    if (resultsData.error === 'resultsNotFound') {
      alert(`You haven't submitted results for this round yet`)
      if (!this.$store.state.loginSettings.adminAvailable) this.$router.push('/tpc')
      return
    } else if (resultsData.error) {
      alert(`Error: Could not get competitor results. [error: ${resultsData.error} - ${resultsData.message}]`)
      return
    }
    this.results = resultsData

    const {data: scramblesData} = await RoundsService.getScrambles({
      roundID: this.roundID,
      solverOrder: this.solverOrder
    })
    // allow unauthenticated solvers to view scrambles
    if (scramblesData.error && scramblesData.error !== 'notAuthenticated') {
      alert(`Error: Could not get scrambles. [error: ${scramblesData.error} - ${scramblesData.message}]`)
      return
    }
    this.scrambles = scramblesData.scrambles
  }
}
</script>

<style scoped>
</style>
